/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Link } from 'gatsby';

const LanguageLink = ({ isInternationalized, language, pathname }) => {
    const availableText = language === 'es'
        ? 'Available '
        : 'Disponible '

    const esPath = language === 'es'
        ? pathname
        : `/es${pathname}`;
    const enPath = language === 'es'
        ? `${pathname.slice(3)}`
        : pathname;

    return (
        <small sx={{ mb: 0 }}>{availableText}
            <Link
                to={language === 'es' ? enPath : esPath}
            >
                {language === 'es' ? "in English" : "en español"}
            </Link>
        </small>
    )
}

export default LanguageLink;
